import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';


class Paginations extends Component {

  handlePageChange = (page) => {
    this.props.onPagination(page.selected + 1)
  }
  render() {
    return (
      <ReactPaginate
        previousLabel={'Previous'}
        nextLabel={'Next'}
        breakLabel={'...'}
        breakClassName={'break-me'}
        pageCount={this.props.pageCount}
        marginPagesDisplayed={0}
        pageRangeDisplayed={this.props.pageRange}
        onPageChange={this.handlePageChange}
        containerClassName={'pagination'}
        pageClassName={'pageSpecific'}
        pageLinkClassName={'pageSpecificLink'}
        subContainerClassName={'pages pagination'}
        activeClassName={'active'}
        previousClassName={'previous'}
        nextClassName={'next'}
      />
    );
  }
}

export default Paginations;
